import { forEach } from "lodash";
import PGSHelper from "../../helpers/PGSHelper.js";
let pgsHelper = new PGSHelper();
import _ from 'lodash';
export default class ReporteZ {
  monedaDefault = "";
  static totalSistema = 0;
  static totalSistemaOtros = 0;
  static subTotalProductos = 0;
  static taxProductos = 0;
  static totalPropinas = 0;
  static totalPropinasOtros = 0;
  constructor() {}

  static getDocData(mainData) {
    /*let tenderTable = this.getTenderTable(contadores, mPagos)
    let familiasTable = this.getFamiliasTable(familias);
    let otrosTable = this.getOtrosTable(contadores, mPagos)*/
    let getTable = this.getTable(mainData.data);
    //let getFirmas = this.getFirmas(mainData.processedDataMesero,mainData.porcentaje)
    let docDefinition = {
      pageMargins: [20, 20, 20, 20],
      content: [
        //header
        {
          columns: [
            {
              // star-sized columns fill the remaining space
              // if there's more than one star-column, available width is divided equally
              width: "25%",
              text: "",
            },
            {
              // fixed width
              width: "50%",
              alignment: "center",
              bold: true,
              text: [
                "REPORTE METODOS PAGO\n",
                "AGRUPADO CLIENTE\n",
                "Del " + mainData.FI + " a " + mainData.FF + "\n",
              ],
            },
            {
              // % width
              width: "25%",
              bold: true,
              text: [
                "Generado: " + mainData.FG + "\n",
                "Hora: " + mainData.HG + "\n",
              ],
            },
          ],
          // optional space between columns
          columnGap: 10,
        },
        {
          columns: [
            {
              // fixed width
              width: "100%",
              table: {
                widths: [100, 50, "*", 50, 100],
                body: getTable,
              },
            },
          ],
          margin: [0, 0, 0, 0],
        },
      ],
    };
    return docDefinition;
  }

  static getTable(data) {
    let times = [
      [
        { text: "Fecha", border: [true, true, true, true], fontSize: 12 },
        {
          text: "Folio",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "center",
        },
        { text: "Cliente", border: [true, true, true, true], fontSize: 12 },
        {
          text: "Monto",
          border: [true, true, true, true],
          fontSize: 12,
          alignment: "right",
        },
        { text: "Alias", border: [true, true, true, true], fontSize: 12 },
      ],
    ];
    let groupedData = [];
    let total = 0;
    let orderedData = _.orderBy(data, ["Cliente","Folio"], "asc");
    
    let grouper = "";
    orderedData.forEach((venta,index) => {
      if (grouper != venta.Cliente) {
        groupedData.push({
          header: true,
          text: venta.Cliente,
        });
      }
      groupedData.push(venta);
      total += Number(venta.TotalMetodoPago)
      grouper = venta.Cliente;

      if(orderedData[index+1]){
        if(orderedData[index+1].Cliente  != venta.Cliente ){
          groupedData.push({
            footer: true,
            text: 'Total',
            total:total
          });
          total = 0
        }
      }else{
           groupedData.push({
            footer: true,
            text: 'Total',
            total:total
          });
          total = 0
      }

    });
    
    groupedData.forEach((venta)=>{
      let rowToAdd = [];
      if(!venta.header & !venta.footer){
        rowToAdd = [
          { text: venta.Fecha + " " + venta.Hora, border: [true, false, true, false], fontSize: 10 },
          { text: venta.Folio, border: [true, false, true, false], fontSize: 10, alignment: 'center' },
          { text: venta.Cliente , border: [true, false, true, false], fontSize: 9 },
          { text: '$'+pgsHelper.formatNumber(venta.TotalMetodoPago), border: [true, false, true, false], fontSize: 10, alignment: 'right' },
          { text: venta.Alias, border: [true, false, true, false], fontSize: 10, alignment: 'left' },

        ]
        times.push(
            rowToAdd
          )
      }
     if(venta.header){
        rowToAdd = [
          { text: venta.text, border: [true, true, true, true], fontSize: 12,colSpan: 5,fillColor:"#CCE3F4" },
        ]
        times.push(
            rowToAdd
          )
      }
      if(venta.footer){
        rowToAdd = [
          { text: venta.text, border: [true, true, true, true], fontSize: 10,colSpan: 3,fillColor:"#DCDCDC"},
          { text: '', border: [true, true, true, true], fontSize: 10 ,fillColor:"#DCDCDC",alignment: 'left' },
          { text: '', border: [true, true, true, true], fontSize: 10,fillColor:"#DCDCDC" },
          { text: '$'+pgsHelper.formatNumber(venta.total), bold: true, border: [true, true, true, true], fontSize: 10 ,alignment: 'right',fillColor:"#DCDCDC"},
          { text: '', border: [true, true, true, true], fontSize: 10,fillColor:"#DCDCDC" },
          
        ]
        times.push(
            rowToAdd
          )
      }
      
    })

    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      table: {
        body: times,
      },
    };

    return times;
  }

  static getFirmas(data, porcentaje) {
    let times = [
      [
        { text: "Mesero", border: [true, true, true, true], fontSize: 12 },
        { text: "Total", border: [true, true, true, true], fontSize: 12 },
        {
          text: "%" + porcentaje,
          border: [true, true, true, true],
          fontSize: 12,
        },
        { text: "Firma", border: [true, true, true, true], fontSize: 12 },
      ],
    ];
    data.forEach((venta) => {
      let rowToAdd = [];
      if (venta.tipo == "footer") {
        rowToAdd = [
          {
            text: venta.Mesero,
            border: [true, true, true, true],
            fontSize: 10,
          },
          {
            text: "$" + pgsHelper.formatNumber(venta.Total),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text:
              "$" +
              pgsHelper.formatNumber((venta.Total * Number(porcentaje)) / 100),
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "right",
          },
          {
            text: " ",
            bold: true,
            border: [true, true, true, true],
            fontSize: 10,
            alignment: "center",
          },
        ];
        times.push(rowToAdd);
      }
    });

    let table = {
      border: [true, false, true, true],
      widths: ["*"],
      heights: 60,
      table: {
        body: times,
      },
    };

    return times;
  }
}
